import { render, staticRenderFns } from "./Bulletins_Liste.vue?vue&type=template&id=6f3c15a4&scoped=true&"
import script from "./Bulletins_Liste.vue?vue&type=script&lang=js&"
export * from "./Bulletins_Liste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c15a4",
  null
  
)

export default component.exports